const RELEASE_SEEN_PREFIX = 'passport_release_seen_';

export function formatAppVersionLabel(version: string, env?: string): string {
  if (!version) return '';
  const label = `v${version}`;
  if (env === 'prod' || !env) return label;
  if (env === 'stage') return `${label} · Stage`;
  if (env === 'local') return `${label} · Local`;
  return `${label} · ${env}`;
}

export function releaseSeenKey(id: string): string {
  return `${RELEASE_SEEN_PREFIX}${id}`;
}

export function hasSeenRelease(id: string): boolean {
  if (!id) return true;
  try {
    return localStorage.getItem(releaseSeenKey(id)) === '1';
  } catch {
    return false;
  }
}

export function markReleaseSeen(id?: string): void {
  if (!id) return;
  try {
    localStorage.setItem(releaseSeenKey(id), '1');
  } catch {
    // ignore quota / private mode
  }
}

export function shouldShowReleaseNotes(notes?: {
  id?: string;
  title?: string;
  body?: string;
  show?: boolean;
} | null): boolean {
  if (!notes || notes.show !== true) return false;
  const id = typeof notes.id === 'string' ? notes.id.trim() : '';
  const title = typeof notes.title === 'string' ? notes.title.trim() : '';
  const body = typeof notes.body === 'string' ? notes.body.trim() : '';
  if (!id || (!title && !body)) return false;
  return !hasSeenRelease(id);
}
